// extracted by mini-css-extract-plugin
export default {"rich-text-editor":"aCrRLNn4AlG3D2hBqMP8e"};